import React from 'react'
import {
  ContainerStyled,
  TitleStyled,
  MessageStyled,
} from '@core/Areas/VenueMode/Components/Racing/RacingNoExclusives.styles'
import { VENUE_FEATURE_NAME } from '@core/Areas/VenueMode/constants'
import { colors } from '@mobi/component-library/Foundations'

const NoExclusivesSvg = () => (
  <svg width='186' height='61' viewBox='0 0 186 61' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g filter='url(#filter0_dd_799_2852)'>
      <g clipPath='url(#clip0_799_2852)'>
        <path
          d='M3 9.49189C3 5.35423 6.35423 2 10.4919 2H175.508C179.646 2 183 5.35423 183 9.49189V49.4487C183 53.5863 179.646 56.9405 175.508 56.9405H10.4919C6.35424 56.9405 3 53.5863 3 49.4486V9.49189Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.0451 10.7837C15.8837 10.6255 15.6254 10.6255 15.464 10.7837L14.8644 11.3711C14.7606 11.4728 14.6112 11.5129 14.4705 11.4767L13.6575 11.2677C13.4386 11.2115 13.2149 11.3406 13.1542 11.5583L12.9287 12.3669C12.8896 12.5068 12.7803 12.6162 12.6403 12.6552L11.8317 12.8808C11.614 12.9415 11.4849 13.1651 11.5412 13.384L11.7501 14.197C11.7863 14.3378 11.7463 14.4872 11.6446 14.591L11.0571 15.1906C10.8989 15.352 10.8989 15.6103 11.0571 15.7717L11.6446 16.3713C11.7463 16.4751 11.7863 16.6245 11.7501 16.7652L11.5412 17.5782C11.4849 17.7971 11.614 18.0208 11.8317 18.0815L12.6403 18.307C12.7803 18.3461 12.8896 18.4554 12.9287 18.5954L13.1542 19.404C13.2149 19.6216 13.4386 19.7508 13.6575 19.6945L14.4705 19.4855C14.6112 19.4494 14.7606 19.4894 14.8644 19.5911L15.464 20.1786C15.6254 20.3367 15.8837 20.3367 16.0451 20.1786L16.6447 19.5911C16.7485 19.4894 16.8979 19.4494 17.0386 19.4855L17.8517 19.6945C18.0705 19.7508 18.2942 19.6216 18.3549 19.404L18.5805 18.5954C18.6195 18.4554 18.7289 18.3461 18.8688 18.307L19.6774 18.0815C19.8951 18.0208 20.0242 17.7971 19.968 17.5782L19.759 16.7652C19.7228 16.6245 19.7628 16.4751 19.8645 16.3713L20.452 15.7717C20.6102 15.6103 20.6102 15.352 20.452 15.1906L19.8645 14.591C19.7628 14.4872 19.7228 14.3378 19.759 14.197L19.968 13.384C20.0242 13.1651 19.8951 12.9415 19.6774 12.8808L18.8688 12.6552C18.7289 12.6162 18.6195 12.5068 18.5805 12.3669L18.3549 11.5583C18.2942 11.3406 18.0705 11.2115 17.8517 11.2677L17.0386 11.4767C16.8979 11.5129 16.7485 11.4728 16.6447 11.3711L16.0451 10.7837ZM13.5749 14.9967C13.5749 13.7929 14.5507 12.817 15.7546 12.817C16.9584 12.817 17.9342 13.7929 17.9342 14.9967C17.9342 15.7521 17.5119 16.2962 17.0797 16.7464C16.9754 16.855 16.8678 16.9608 16.7638 17.0631L16.7503 17.0764C16.6411 17.1837 16.5362 17.2872 16.4373 17.3914C16.2386 17.6009 16.0763 17.8011 15.9712 18.0113C15.9302 18.0933 15.8463 18.1452 15.7546 18.1452C15.6628 18.1452 15.579 18.0933 15.5379 18.0113C15.4328 17.8011 15.2705 17.6009 15.0718 17.3914C14.9729 17.2872 14.868 17.1837 14.7588 17.0764L14.7453 17.0631C14.6413 16.9608 14.5338 16.855 14.4295 16.7464C13.9972 16.2962 13.5749 15.7521 13.5749 14.9967ZM15.7546 15.6022C16.1558 15.6022 16.4811 15.2769 16.4811 14.8756C16.4811 14.4743 16.1558 14.1491 15.7546 14.1491C15.3533 14.1491 15.028 14.4743 15.028 14.8756C15.028 15.2769 15.3533 15.6022 15.7546 15.6022Z'
          fill={colors.warning[700]}
        />
        <rect x='24' y='10.7405' width='57.4378' height='9.98919' rx='4.99459' fill='#F0EFF1' />
        <rect
          x='148.038'
          y='10.7405'
          width='27.4703'
          height='9.98919'
          rx='4.99459'
          fill='#F0EFF1'
        />
        <rect
          x='10.4922'
          y='26.9729'
          width='39.9568'
          height='9.98919'
          rx='4.99459'
          fill='#E1DFE3'
        />
        <rect
          x='10.4922'
          y='39.4595'
          width='57.4378'
          height='9.98919'
          rx='4.99459'
          fill='#E1DFE3'
        />
        <path
          d='M153.033 30.0945C153.033 28.3705 154.431 26.9729 156.155 26.9729H172.387C174.111 26.9729 175.509 28.3705 175.509 30.0945V46.327C175.509 48.051 174.111 49.4486 172.387 49.4486H156.155C154.431 49.4486 153.033 48.051 153.033 46.327V30.0945Z'
          fill='#F0EFF1'
        />
        <rect x='157.771' y='34.7107' width='13' height='7' rx='3.5' fill='#E1DFE3' />
      </g>
      <path
        d='M10.4922 2.5H175.508C179.369 2.5 182.5 5.63067 182.5 9.49219V49.4482C182.5 53.3098 179.369 56.4404 175.508 56.4404H10.4922C6.63067 56.4404 3.5 53.3098 3.5 49.4482V9.49219C3.5 5.63067 6.63067 2.5 10.4922 2.5Z'
        stroke='#F7F6F7'
      />
    </g>
    <defs>
      <filter
        id='filter0_dd_799_2852'
        x='0'
        y='0'
        width='186'
        height='60.9404'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.101961 0 0 0 0 0.054902 0 0 0 0 0.137255 0 0 0 0.06 0'
        />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_799_2852' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1' />
        <feGaussianBlur stdDeviation='1.5' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.101961 0 0 0 0 0.054902 0 0 0 0 0.137255 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_799_2852'
          result='effect2_dropShadow_799_2852'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_799_2852'
          result='shape'
        />
      </filter>
      <clipPath id='clip0_799_2852'>
        <path
          d='M3 9.49189C3 5.35423 6.35423 2 10.4919 2H175.508C179.646 2 183 5.35423 183 9.49189V49.4487C183 53.5863 179.646 56.9405 175.508 56.9405H10.4919C6.35424 56.9405 3 53.5863 3 49.4486V9.49189Z'
          fill='white'
        />
      </clipPath>
    </defs>
  </svg>
)

export const RacingNoExclusives: React.FC = () => {
  return (
    <ContainerStyled>
      <NoExclusivesSvg />
      <div>
        <TitleStyled>No {VENUE_FEATURE_NAME}</TitleStyled>
        <MessageStyled>
          We've got no more offers to show you at the moment. Refresh this page or check back later!
        </MessageStyled>
      </div>
    </ContainerStyled>
  )
}
